import { take, call, put, select, race } from 'redux-saga/effects';
import { changeCurrentMediaSource, setCurrentFolderId, setCurrentSubfolderId, fetchMoreGallections, fetchMoreGallectionsDone, reloadStashStreamDone } from '../actions';
import { STREAM__WITH_OFFSET__FETCH_SUCCESS, STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE } from '../../Stream/withOffset/actions';
import { getCurrentMediaSource, getTopLevelGallections, getCurrentFolderId, getCurrentSubfolderId } from '../selectors';
import { getGallectionDeviationStreamId } from '../helpers';
import { withOffset } from '../../Stream';
import { MediaSourceType } from '../types';
function* getOrLoadGallections() {
    let gallections = yield select(getTopLevelGallections);
    if (!gallections || gallections.length === 0) {
        // gallections for the currentMediaSource have not yet been loaded, load them
        yield put(fetchMoreGallections());
        // wait for a fetch more gallections to complete
        let done = false;
        while(!done){
            const { payload } = yield take(fetchMoreGallectionsDone);
            done = (payload === null || payload === void 0 ? void 0 : payload.type) === MediaSourceType.STASH;
        }
        gallections = yield select(getTopLevelGallections);
    }
    return gallections;
}
export function* reloadStashStream() {
    const currentMediaSource = yield select(getCurrentMediaSource);
    let currentFolderId = yield select(getCurrentFolderId);
    const currentSubfolderId = yield select(getCurrentSubfolderId);
    if (currentMediaSource !== MediaSourceType.STASH) {
        // change the media source to stash
        yield put(changeCurrentMediaSource(MediaSourceType.STASH));
        const gallections = yield call(getOrLoadGallections);
        if (!gallections.length) {
            // still no folders? everything is terrible, let's crash gracefully
            yield put(reloadStashStreamDone());
            return;
        }
        // First stash folder is the "Featured" folder which contains items uploaded to the stash root
        currentFolderId = gallections[0].folderId;
    } else if (!currentFolderId) {
        // If no stash folder is selected pick the first one as we do when switching media source
        const stashFolders = yield select(getTopLevelGallections);
        currentFolderId = stashFolders && stashFolders[0] && stashFolders[0].folderId;
    }
    if (currentFolderId || currentSubfolderId) {
        // If the user did not have any items in stash, and the stash gallections were
        // cached, we need to uncache the stream in order to get the fresh items
        const streamId = getGallectionDeviationStreamId(MediaSourceType.STASH, currentSubfolderId !== null && currentSubfolderId !== void 0 ? currentSubfolderId : currentFolderId);
        yield put(withOffset.actions.deleteStream(streamId));
        // Load this folder id
        if (currentSubfolderId) {
            yield put(setCurrentSubfolderId(currentSubfolderId));
        } else if (currentFolderId) {
            yield put(setCurrentFolderId(currentFolderId));
        }
        // wait for a stash fetch success event
        let done = false;
        while(!done){
            const { fetchSuccess, fetchSuccessDeduped } = yield race({
                fetchSuccess: take(STREAM__WITH_OFFSET__FETCH_SUCCESS),
                fetchSuccessDeduped: take(STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE)
            });
            const actionStreamId = (fetchSuccess === null || fetchSuccess === void 0 ? void 0 : fetchSuccess.streamId) || (fetchSuccessDeduped === null || fetchSuccessDeduped === void 0 ? void 0 : fetchSuccessDeduped.streamId);
            done = actionStreamId === streamId;
        }
    }
    yield put(reloadStashStreamDone());
}
export default reloadStashStream;

//# sourceMappingURL=reloadStashStream.js.map